import { FormDataType } from "DataTypes/Form";
import dayjs from "dayjs";
import DateTime from "Utils/DateTime";

export const MeetingCreationFormArr: FormDataType[] = [
  {
    id: "topic",
    label: "Topic",
    placeholder: "Enter Meeting Topic",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "input",
    required: true,
  },
  {
    id: "startAt",
    label: "Start Date",
    placeholder: "Select Start Date",
    boxType: "mui-date",
    boxSize: 6,
    validatetype: "date",
    required: true,
    minVal: DateTime.currentDate,
  },
  {
    id: "startTime",
    label: "Start Time",
    placeholder: "Select Start Time",
    boxType: "mui-time",
    boxSize: 6,
    validatetype: "time",
    required: true,
  },
  {
    id: "durationInMinutes",
    label: "Duration (in minutes)",
    placeholder: "Enter Meeting Duration",
    boxType: "input-box",
    type: "number",
    minVal: "10",
    maxVal: "60",
    boxSize: 6,
    validatetype: "duration",
    required: true,
  },
  {
    id: "agenda",
    label: "Agenda",
    placeholder: "Enter Meeting Agenda",
    boxType: "input-box",
    boxSize: 12,
    validatetype: "input",
    required: true,
    multiline: true,
    multilineRows: 4,
  },
];
